import { render } from "./Index.vue?vue&type=template&id=cf92b770&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=cf92b770&lang=scss&scoped=true"

import exportComponent from "D:\\QYYY\\mall_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf92b770"]])

export default __exports__